import { DynamoDBClient, GetItemCommand, QueryCommand, ScanCommand } from '@aws-sdk/client-dynamodb';
import { unmarshall } from '@aws-sdk/util-dynamodb';
import { signIn, signOut, getCurrentUser } from '@aws-amplify/auth'; // Import individual methods
import { signInSuccess, signOutSuccess, setUser, fetchNotificationsStart, fetchNotificationsFailure, fetchNotificationsSuccess } from '../reducers/AuthSlice';
import { HealthClient, DescribeEventsCommand } from "@aws-sdk/client-health";

// Function to get credentials from environment variables (Amplify will inject these)
const getClientWithCredentials = () => {
  const accessKeyId = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
  const secretAccessKey = process.env.REACT_APP_AWS_SECRET_ACCESS_KEY;
  const region = process.env.REACT_APP_AWS_REGION;

  return new DynamoDBClient({
      region: region,
      credentials: {
          accessKeyId,
          secretAccessKey,
      },
  });
};

// Action to handle user sign-in
export const signInUser = (username, password) => async (dispatch) => {
  try {
    const user = await signIn(username, password);
    dispatch(signInSuccess(user));
    dispatch(fetchCurrentUser());
  } catch (error) {
    console.error("Error signing in:", error);
  }
};

// Action to handle user sign-out
export const signOutUser = () => async (dispatch) => {
  try {
    await signOut(); 
    dispatch(signOutSuccess());
    dispatch(setUser(null)); 
  } catch (error) {
    console.error("Error signing out:", error);
  }
};

// Action to fetch the current authenticated user
export const fetchCurrentUser = () => async (dispatch) => {
  try {
    const user = await getCurrentUser();
    dispatch(setUser(user));
  } catch (error) {
    dispatch(setUser(null));
  }
};


export const fetchNotifications = () => async (dispatch) => {
  try {
    dispatch(fetchNotificationsStart());

    const client = getClientWithCredentials();
    const params = { TableName: "Notifications" };
    const command = new ScanCommand(params);
    const response = await client.send(command);

    const notifications = response.Items ? response.Items.map((item) => unmarshall(item)) : [];

    if (notifications.length === 0) {
      console.log("AuthActions.js - No notifications found.");
    }

    notifications.sort((a, b) => a.notification_id - b.notification_id);
  
    dispatch(fetchNotificationsSuccess(notifications));
  } catch (error) {
    console.error("AuthActions.js - Error fetching notifications:", error);
    dispatch(fetchNotificationsFailure());
  }
};
